<div class="w-full h-full hidden md:flex flex-col justify-between">
	<div
		class="header flex border-b h-24 border-b-neutral-color-c justify-between w-full items-center"
	>
		<div class="title px-5" *ngIf="module.modulePk">
			<span class="name-select-client">{{ module.name }}</span>
			<div class="flex">
				<span class="subname-select-client mr-4">ID: {{ module.modulePk }}</span>
			</div>
		</div>
		<div *ngIf="isModuleSelected" class="pr-2">
			<app-tabs [tabs]="tabs" [view]="viewSelect" (active)="tabSelect($event)"></app-tabs>
		</div>
	</div>
	<div class="body-client h-full flex flex-col justify-between">
		<div class="flex justify-center items-center h-full flex-col" *ngIf="!isModuleSelected">
			<img src="../../../../assets/icon/notFile.svg" />
			<span class="notFount"> {{ dataTranslate.textNotSelected }} </span>
		</div>
		<div
			class="h-full w-full flex items-start p-16"
			*ngIf="viewSelect === '1' && isModuleSelected && !loading"
		>
			<div class="contentGeneral flex w-full h-full">
				<div class="pr-4 w-60 min-w-[calc(250px)]">
					<div
						[ngClass]="{
							borderUpdate: !isEditModule,
							'active-drag': isDragActive && !isEditModule
						}"
						class="inputDrag"
						(dragover)="onDragOver()"
						(dragleave)="onDragLeave($event)"
					>
						<mat-icon
							*ngIf="!isEditModule"
							class="text-primary-color mr-1 material-icons-outlined absolute top-3 right-1"
						>
							edit
						</mat-icon>
						<img imgNotFound class="w-auto h-auto max-h-48" src="{{ fileUrl }}" />

						<zf-s3-upload-image
							*ngIf="!isEditModule"
							[version]="'1'"
							[url]="'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'"
							[urlPresigned]="'https://api-services.mango-soft.com/stage/get-presigned-url'"
							[bucket]="'cdn.mango-soft.com'"
							[folder]="'access-control/files'"
							[client]="'zerofractal'"
							[imageZoom]="false"
							(urlUploaded)="urlUploadedHandle($event)"
							(urlUploadedError)="urlUploadedErrorHandle($event)"
						></zf-s3-upload-image>
					</div>
				</div>
				<div class="pl-4 w-full">
					<div class="grid mb-4">
						<label class="titleModuleSelect" for=""> {{ dataTranslate.textName }} </label>
						<input
							type="text"
							[disabled]="isEditModule"
							class="input-app input-name nameModuleSelect"
							[(ngModel)]="name"
						/>
					</div>

					<div class="grid mb-4">
						<label class="titleModuleSelect" for=""> {{ dataTranslate.textSystem }} </label>
						<span class="nameModuleSelect">{{ module.name }}</span>
					</div>

					<div class="grid mb-4">
						<label class="titleModuleSelect" for=""> {{ dataTranslate.customDomain }} </label>
						<span class="nameModuleSelect">{{ module.domain }}</span>
					</div>
					<div class="grid mb-4">
						<label class="titleModuleSelect" for=""> {{ dataTranslate.mainHost }} </label>
						<input
							type="text"
							[disabled]="isEditModule"
							class="input-app input-name nameModuleSelect nameHost-main"
							[placeholder]="dataTranslate.mainHostPlaceholder"
							[(ngModel)]="mainHost"
						/>
					</div>
					<div class="grid mb-4">
						<label class="titleModuleSelect" for=""> {{ dataTranslate.textHost }} </label>

						<mat-chip-grid #chipList aria-label="Search...">
							<mat-chip-row
								*ngFor="let host of valueHost"
								[removable]="removable"
								(removed)="remove(host)"
							>
								{{ host }}
								<button matChipRemove *ngIf="removable && !isEditModule">
									<mat-icon>cancel</mat-icon>
								</button>
							</mat-chip-row>
							<input
								id="input-search-general"
								placeholder="New host..."
								class="input-app input-name"
								[disabled]="isEditModule"
								[matChipInputFor]="chipList"
								(input)="enterHost($event)"
								[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
								[matChipInputAddOnBlur]="addOnBlur"
								(matChipInputTokenEnd)="add($event)"
							/>
						</mat-chip-grid>
					</div>
				</div>
			</div>
		</div>
		<div class="h-full" *ngIf="viewSelect === '2' && isModuleSelected && !loading">
			<ngx-codejar
				[highlightMethod]="highlightMethodCss"
				[(code)]="css"
				class="code-editor"
				[ngClass]="{ 'code-editor-inactive': isEditModule }"
				[showLineNumbers]="true"
			></ngx-codejar>
			<a id="a" auto> </a>
		</div>
		<div class="h-full" *ngIf="viewSelect === '3' && isModuleSelected && !loading">
			<ngx-codejar
				[highlightMethod]="highlightMethodJson"
				[(code)]="frontend"
				class="code-editor"
				[ngClass]="{ 'code-editor-inactive': isEditModule }"
				[showLineNumbers]="true"
			></ngx-codejar>
			<a id="a" auto> </a>
		</div>
		<div class="h-full" *ngIf="viewSelect === '4' && isModuleSelected && !loading">
			<ngx-codejar
				[highlightMethod]="highlightMethodJson"
				[(code)]="backend"
				class="code-editor"
				[ngClass]="{ 'code-editor-inactive': isEditModule }"
				[showLineNumbers]="true"
			></ngx-codejar>
			<a id="a" auto> </a>
		</div>
		<div class="h-full" *ngIf="viewSelect === '5' && isModuleSelected && !loading">
			<app-view-deploy-config></app-view-deploy-config>
		</div>
		<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		<div class="btn-save" *ngIf="isModuleSelected && viewSelect != '5'">
			<button (click)="editModule()">
				<mat-icon class="text-primary-color mr-1 material-icons-outlined">
					{{ isEditModule ? 'edit' : 'save_as' }}
				</mat-icon>
				<span class="font-lato">
					{{ isEditModule ? dataTranslate.buttonEdit : dataTranslate.buttonSave }}
				</span>
			</button>
		</div>
	</div>
</div>
